// removed by extract-text-webpack-plugin
module.exports = {"component":"_3QmRh1Gu6da0tQE2XyT_lR","careRecordWrapper":"_3XqlpoZbprm3vRbykL3no9","secondaryHeader":"_1TLktjnkVfltMbHsqLQL-_","secondaryHeaderFlexEnd":"_1F8KL3Wr3h5kvm7VAS1R2_","messagePlaceholder":"_25l3RZdiEWLX4EoCzgSj03","utilities":"mMvwbWUrCD2bJLmgvAb7F","contentPanel":"BAIHNoZnHzyYBOVbjfMKY","actionsPanel":"_1w0NgCOKYqlH_Rxv-wCaRw","menuItem":"ZIYFIP6vd3zL16C1BCP4g","menuTitle":"_1uOhSfOJr1I18N4bWIUBxQ","noRenderPlaceholder":"_2kD6WMUtX3mncPpCwQ9rLV","HealthLandingPageBackButtonContainer":"_2uqdYojp1b41rjS9UeqbH9","secondaryMenu":"_2FH_ifSoU8IafXdz5cSHMV"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Health/HealthLandingPage/HealthLandingPage.css
// module id = 1297
// module chunks = 0